"use client";


import Link from 'next/link';
import Button from "@/components/Button";
import * as classes from "../Button/Button.css";
import { useParams, usePathname } from "next/navigation";
import { useResponsive } from '@/client/hooks/useResponsive';
import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { sendEventToGTM } from '@/helpers/gtm.helper';
import { useDynamicAltText } from '@/hooks/useDynamicAltText';

const size = {
  xl: "py-[20px] px-7 !text-[21px] leading-[27px]",
  l: "py-[12px] px-4 text-[16px] leading-[24px]",
  m: "py-[8px] px-2 text-[16px] leading-[24px]",
  s: "py-[4px] px-[12px] !text-[12px] leading-[16px]",
  z: "",
};

// Create a wrapper for the button component
// this allows us to correctly map the url and value
export const ButtonWrapper = (props: any) => {
  const { url, value, id, targetBlank, cssClass, type, hide = false, showInSection = false, sectionId, GTMLabel, intent, ...buttonProps } = props
  const [sectionVisible, setSectionVisible] = useState(false);
  const [btnType, setBtnType] = useState("button");
  const params = useParams<{ locale: string; }>();
  const pathname = usePathname();
  const isInContentful = (typeof window !== "undefined") && window.self !== window.top;
  const linkRef = useRef<HTMLAnchorElement | null>(null);
  const altText = useDynamicAltText(linkRef);

  const elData = props?.data; //useContentfulLiveUpdates(props?.data);
  // const inspectorModeProps = useContentfulInspectorMode();

  const { isSm } = useResponsive();

  const onAction = (e: any) => {
    if (props?.eventName) {
      window.dispatchEvent(new Event(props?.eventName));
    }
    else {
      typeof buttonProps?.action === 'function' && buttonProps?.action(e)
    }
  }

  const checkVisible = () => {
    if (showInSection) {
      const section = document?.getElementById(sectionId)
      if (section) {
        const observer = new IntersectionObserver((entries) => {
          entries?.forEach(e => {
            if (e?.isIntersecting) {
              setSectionVisible(true)
            }
            else {
              setSectionVisible(false)
            }
          })
        }, { rootMargin: "-200px 0px -100px 0px" });
        observer?.observe(section)
      }
    }
  }

  checkVisible();

  useEffect(() => {
    if (url && ["button", "submit", "reset"].includes(type)) {
      setBtnType(type);
    } else if (url) {
      // if(type !== "link") {
      //   setBtnType(type);
      // } else {
      setBtnType("link");
      // }
    } else {
      setBtnType(type || "button");
    }
    // console.log("props ------ ", props, targetBlank)
  }, [url, type])

  // let targetURL = url;
  // if (url && pathname === ('/' + params.locale)) {
  //   targetURL = '/' + params.locale + (url.indexOf('/') !== 0 ? ('/' + url) : url);
  // }


  return (
    <>
      {
        // !props?.hide && (url ? (
        !props?.hide && ((btnType === "link") ? (
          (isInContentful ? true : (showInSection ? sectionVisible : true)) && ((targetBlank === "true" || targetBlank === "false") ? (
            <Link
              // {...inspectorModeProps({ fieldId: elData?.contentType || "baseplateButton", entryId: elData?.id })}
              id={id} href={`${url}`}
              aria-label={url as string}
              className={
                classNames(`${elData?.content?.variant === "link" ?
                  "html-link" : "btn"} 
                    btn-${elData?.content?.variant}`, elData?.title || '',
                  // rest?.btnpProps?.['data-cf-node-id'] ? `cfstyles-${rest?.btnpProps?.['data-cf-node-id']}` : '',
                  'rounded-button',
                  elData?.content?.cssClass, cssClass, (buttonProps?.variant || "primary"),
                  "group font-buttonLabel relative outline-none",
                  hide ? "hidden" : "",
                  // (!Array.isArray(rest?.variant) && (classes.variant[rest?.variant], classes.focusVisible[rest?.variant])),
                  classes?.variant[buttonProps?.variant || "primary"],
                  // classes.variant[rest?.variant!],
                  classes?.focusVisible[buttonProps?.variant || "primary"],
                  // rest?.iconLightVariant && classes.lightAppearance[rest?.variant],
                  [size[(buttonProps?.size as "m" | "l" | "s" | "xl" | "z") || "m"]],
                  {
                    "rounded-s-none focus-visible:after:rounded-s-none": buttonProps?.flatSide === "left",
                    "rounded-r-none focus-visible:after:rounded-r-none": buttonProps?.flatSide === "right",
                    // [classes?.size[rest?.size || "m"]]: typeof children === "string",
                    // [classes.iconSize[rest?.size]]: typeof rest?.children !== "string",
                  },
                  `${elData ? (`${elData?.content?.variant === "link" ? "html-link" : ""} btn-${elData?.content?.variant}`) : ''}`,
                  elData?.title || '',
                  elData?.content?.rounded ? 'rounded' : '',
                  buttonProps?.className,
                  cssClass,
                )}
              style={{ ...buttonProps?.style, ...(elData?.content?.customStyles || {}) }}
              tabIndex={buttonProps?.tabIndex}
              target={targetBlank === "true" ? "_blank" : (buttonProps?.reload ? "_parent" : "_self")}
              onClick={() => {
                if (buttonProps?.eventName) {
                  window.dispatchEvent(new Event(buttonProps?.eventName));
                }
                if (buttonProps?.GTMEnabled) {
                  // Send GTM event for link clicks
                  sendEventToGTM({
                    event: `Link ${buttonProps?.GTMEvent || "Click"}`,
                    component: "Link",
                    componentId: elData?.content?.id || id,
                    type: elData?.content?.type || type,
                    label: GTMLabel || value || elData?.content?.caption || elData?.content?.buttonText || altText,
                    pagePath: window.location.pathname,
                    linkUrl: url || "NA",
                    onClickEvent: buttonProps?.eventName || "NA",
                    location: buttonProps?.location || "NA",
                    ...(intent ? { clickIntent: intent } : {}),
                    ...buttonProps?.GTMPayload
                  })
                }
              }}
            >
              {value}
              {/* -- buttonProps | button: <pre>{JSON.stringify(buttonProps, null, 2)}</pre> */}
            </Link>
          ) : (
            <Link href={`${url}`} aria-label={url as string} target={targetBlank === true ? '_blank' : '_self'}>
              <Button type={type}  intent={intent} btnpProps={buttonProps} id={id} button_link={url} cssClass={cssClass} action={(e) => onAction(e)}>
                {value}
                {/* -- buttonProps | link/button: <pre>{JSON.stringify(buttonProps, null, 2)}</pre> */}
              </Button>
            </Link>

          ))
        ) : (
          (isInContentful ? true : (showInSection ? sectionVisible : true)) && <Button intent={intent} type={type} btnpProps={buttonProps} cssClass={cssClass} id={id} action={(e) => onAction(e)}>
            {value}
            {/* -- buttonProps | button: <pre>{JSON.stringify(buttonProps, null, 2)}</pre> */}
          </Button>
        ))
      }
    </>
  )
}
